import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Creators as bseActions } from '../../../../../../../../domain/useCases/bse/getFormBseUseCase';
import { Creators as deleteActions } from '../../../../../../../../domain/useCases/bse/deleteFileBseUseCase';
import { Creators as downloadActions } from '../../../../../../../../domain/useCases/dropBox/getUrlDocumentUseCase';
import { Creators as uploadActions } from '../../../../../../../../domain/useCases/bse/uploadBseDocument';
import SupportingDocumentsView from './SupportingDocumentsView';
import useSnackbarFields from '../../hooks/useSnackbarFields';
import Snackbar from '../../../../../../../components/Snackbar';
import ModuleContainer from '@/presentation/components/Container';
import Back from '@/presentation/reusables/Button/Back';
import { BackButtonContainer } from '../index/styled';

const SupportingDocumentsController = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { fieldsSnackbar, validateCommon, Types } = useSnackbarFields();

  const [isValidDocuments, setIsValidDocuments] = useState(false);

  const { request } = useSelector((state: any) => state.procedureStudentStatus);

  const idRequest = request?.id || 0;

  const { documents: documentsBse, dbToken: tokenDB } = useSelector(
    (state: any) => state.getFormBse
  );

  const { isLoading: isUploadingDocument, data: dataUploadDocument } =
    useSelector((state: any) => state.uploadDocumentBse);

  const { isLoading: isDeletingDocument, data: dataDeleteDocument } =
    useSelector((state: any) => state.deleteFileBse);

  const { data: dropboxResponse } = useSelector(
    (state: any) => state.getUrlDocument
  );

  useEffect(() => {
    if (dataUploadDocument) {
      validateCommon(Types.success, '¡Listo!', 'Tu avance ha sido guardado');
    }
    if (dataDeleteDocument) {
      validateCommon(Types.success, '¡Listo!', 'Tu avance ha sido guardado');
    }
  }, [isUploadingDocument, isDeletingDocument]);

  useEffect(() => {
    if (dropboxResponse) {
      window.open(dropboxResponse?.link, '_blank');
      dispatch(downloadActions.getUrlDocumentClear());
    }
  }, [dropboxResponse]);

  useEffect(() => {
    if (!documentsBse) dispatch(bseActions.getFormBse(idRequest));
  }, [documentsBse]);

  const handlerBack = () => {
    history.push('/tramites/becas-descuentos/bse/progreso');
  };

  const sendDocuments = (documents: any) => {
    dispatch(uploadActions.uploadBseDocument(idRequest, documents, false));
  };

  const deleteUploadedFile = (ids: number[]) => {
    dispatch(deleteActions.deleteFileBse(ids));
  };

  const downloadUploadedFile = (path: string) => {
    dispatch(downloadActions.getUrlDocument(path, tokenDB));
  };

  return (
    <ModuleContainer
      containerType="subsection"
      data-testid="cmp-bse-form-index-view"
    >
      <BackButtonContainer>
        <Back dataTestid="cmp-buttom-back-refactor" onClick={handlerBack} />
      </BackButtonContainer>

      <SupportingDocumentsView
        deleteUploadedFile={(ids) => deleteUploadedFile(ids)}
        documentsBse={documentsBse || []}
        downloadUploadedFile={downloadUploadedFile}
        handlerBack={() => handlerBack()}
        isProcessing={isUploadingDocument || isDeletingDocument}
        isValidDocuments={isValidDocuments}
        sendDocuments={(data) => sendDocuments(data)}
        setIsValidDocuments={setIsValidDocuments}
      />
      <Snackbar timeout={5000} fieldsSnackbar={fieldsSnackbar} />
    </ModuleContainer>
  );
};

export default SupportingDocumentsController;
